'use client'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import React, { useEffect, useMemo, useState } from 'react'
import { InfoIcon, CircleIcon, ChevronRightIcon } from './Icons'
import { useQuizStore } from '@/store/useQuizStore'

export const TimelineSlider = ({ data }: { data: any }) => {
  const slides = data.items
  const setSingle = useQuizStore((s) => s.setSingle)
  const savedText = useQuizStore((s) => s.getAnswer(data.name))
  const defaultActive = data.items.findIndex((el: any) => el === savedText)
  const [activeSlide, setActiveSlide] = useState(defaultActive)
  const lineCount = 19

  const lineHeights = useMemo(() => {
    return Array.from({ length: lineCount }, (_, i) => {
      return i
    })
  }, [lineCount])

  useEffect(() => {
    setSingle(data.name, slides[activeSlide])
  }, [activeSlide])

  return (
    <div className="relative w-screen -ml-5 px-5 max-w-md mx-auto mt-[14.5vh] overflow-hidden">
      <div className="before:absolute before:bg-buttonGradient before-line before:w-[3px] before:rounded-[4px] before:left-1/2 before:-translate-x-1/2 before:h-[128px] before:bottom-[75px] before:z-20">
        <div className="absolute !left-3 !top-[62%] after:!hidden -translate-y-1/2 z-10 scale-x-[-1] cursor-pointer swiper-button-prev bg-[#ECEDEF] rounded-full !w-10 !h-10 flex items-center justify-center ">
          <ChevronRightIcon className="!w-5 !h-5" />
        </div>
        <div className="absolute !right-3 !top-[62%] -translate-y-1/2 after:!hidden z-10 cursor-pointer swiper-button-next bg-[#ECEDEF] rounded-full !w-10 !h-10 flex items-center justify-cente">
          <ChevronRightIcon className="!w-5 !h-5" />
        </div>
        <CircleIcon className="absolute top-[98px] -translate-y-1/2 z-10 left-1/2 -translate-x-1/2 w-[440px] h-auto" />
        <Swiper
          modules={[Navigation]}
          spaceBetween={0}
          initialSlide={defaultActive}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          onSlideChange={(e: any) => {
            setActiveSlide(e.activeIndex)
          }}
          slidesPerView={2}
          className="!overflow-visible relative left-[6px] before:absolute before:z-10 after:z-10 before:top-0 before:-left-7 before:w-16 before:h-full before:bg-shadowGradient after:absolute after:scale-x-[-1] after:top-0 after:-right-5 after:w-16 after:h-full after:bg-shadowGradient"
        >
          {slides.map((text: string, index: number) => (
            <SwiperSlide
              key={index}
              className="pt-[98px] group-slide group !flex pr-[2.3vw] has-[+swiper-slide:last]:!mr-0"
            >
              <div
                className={`${index === 0 ? 'flex justify-end w-full' : 'flex justify-between w-full'}`}
              >
                {index !== 0 &&
                  lineHeights.map((h, i) => (
                    <div
                      key={i}
                      className="transition-all bg-gray-300 w-px min-w-px line duration-200 rounded-full h-[148px]"
                    />
                  ))}
              </div>
              <p className="tools opacity-0 transition-all duration-200 bg-white text-black py-2 px-6 rounded-2xl font-semibold absolute top-0 right-0 translate-x-1/2 whitespace-nowrap">
                {text}
                <svg
                  className="absolute top-full left-1/2 -translate-x-1/2"
                  width="16"
                  height="8"
                  viewBox="0 0 16 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8 8L0 0H16L8 8Z" fill="#101A36" />
                </svg>
              </p>
            </SwiperSlide>
          ))}
          <SwiperSlide className="pt-[98px] group group-slide !flex pr-[2.3vw] has-[+swiper-slide:last]:!mr-0"></SwiperSlide>
        </Swiper>
        <CircleIcon className="absolute bottom-[63px] translate-y-1/2 z-10 left-1/2 -translate-x-1/2 w-[440px]  h-auto" />
      </div>
      <div className="flex  items-center gap-1 text-[#101A36B2] font-semibold text-[14px] justify-center mt-[44px]">
        <InfoIcon />
        Drag to adjust your answer
      </div>
    </div>
  )
}
